var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListItem',_vm._b({attrs:{"subtitle":_vm.active.name,"title":_vm.$t('settings.language')}},'ListItem',_vm.$attrs,false),[_c('ListItemCircle',{attrs:{"slot":"icon"},slot:"icon"},[_c('Globe')],1),_vm._t("default",null,{"slot":"right"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }